var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-tooltip',{attrs:{"text":_vm.$t('edit'),"position":"bottom"}},[_c('vs-button',{staticClass:"text-center editButton",attrs:{"color":"primary","type":"border","icon-pack":"feather","icon":"icon-edit","size":"small"},on:{"click":function($event){$event.preventDefault();return _vm.click.apply(null, arguments)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }